
// src/data/ReportersData.js

import kingAltadorIcon from "../assets/anon-icons/altador.png";
import acPlayerIcon from "../assets/anon-icons/acplayer.png";
import ambraIcon from "../assets/anon-icons/ambra.png";
import amiraIcon from "../assets/anon-icons/amira.png";
import bruceyBIcon from "../assets/anon-icons/bruceyb.png";
import deadChiaIcon from "../assets/anon-icons/deadchia.png";
import esophagorIcon from "../assets/anon-icons/esophagor.png";
import fyoraIcon from "../assets/anon-icons/fyora.png";
import garooIcon from "../assets/anon-icons/garoo.png";
import hannahIcon from "../assets/anon-icons/hannah.png";
import hansoIcon from "../assets/anon-icons/hanso.png";
import horaceIcon from "../assets/anon-icons/horace.png";
import judgeHogIcon from "../assets/anon-icons/hog.png";
import ilereIcon from "../assets/anon-icons/ilere.png";
import iscaIcon from "../assets/anon-icons/isca.png";
import jazanIcon from "../assets/anon-icons/jazan.png";
import jerdanaIcon from "../assets/anon-icons/jerdana.png";
import kanrikIcon from "../assets/anon-icons/kanrik.png";
import kassIcon from "../assets/anon-icons/kass.png";
import kauvaraIcon from "../assets/anon-icons/kauvara.png";
import kevinIcon from "../assets/anon-icons/kevin.png";
import kikolakeIcon from "../assets/anon-icons/kikolake.png";
import lucieIcon from "../assets/anon-icons/lucie.png";
import mcgeeIcon from "../assets/anon-icons/mcgee.png";
import nabileIcon from "../assets/anon-icons/nabile.png";
import nigelIcon from "../assets/anon-icons/nigel.png";
import nightsteedIcon from "../assets/anon-icons/nightsteed.png";
import rosieIcon from "../assets/anon-icons/rosie.png";
import sashaIcon from "../assets/anon-icons/sasha.png";
import slothIcon from "../assets/anon-icons/sloth.png";
import sophieIcon from "../assets/anon-icons/sophie.png";
import xandraIcon from "../assets/anon-icons/xandra.png";
import ylanaIcon from "../assets/anon-icons/ylana.png";


export const ReportersData = [
  { name: "King Altador", image: kingAltadorIcon },
  { name: "Ambra the Aisha", image: ambraIcon },
  { name: "Captain Derlyn Fonnet", image: acPlayerIcon },
  { name: "Queen Amira", image: amiraIcon },
  { name: "Brucey B", image: bruceyBIcon },
  { name: "Dead Chia", image: deadChiaIcon },
  { name: "Esophagor", image: esophagorIcon },
  { name: "Fyora", image: fyoraIcon },
  { name: "Commander Garoo", image: garooIcon },
  { name: "Hannah the Adventurer", image: hannahIcon },
  { name: "Hanso the Thief", image: hansoIcon },
  { name: "Horace the Poor", image: horaceIcon },
  { name: "Judge Hog", image: judgeHogIcon },
  { name: "Ilere", image: ilereIcon },
  { name: "Isca", image: iscaIcon },
  { name: "King Jazan", image: jazanIcon },
  { name: "Jerdana", image: jerdanaIcon },
  { name: "Kanrik", image: kanrikIcon },
  { name: "Lord Kass", image: kassIcon },
  { name: "Kauvara", image: kauvaraIcon },
  { name: "Kevin the Korbat", image: kevinIcon },
  { name: "Kiko Lake Team", image: kikolakeIcon },
  { name: "Lucie the Collector", image: lucieIcon },
  { name: "Bug Eye McGee", image: mcgeeIcon },
  { name: "Queen Nabile", image: nabileIcon },
  { name: "Nigel the Stockbroker", image: nigelIcon },
  { name: "Nightsteed", image: nightsteedIcon },
  { name: "Rosie the Grarrl", image: rosieIcon },
  { name: "Sasha the Dancer", image: sashaIcon },
  { name: "Dr. Sloth", image: slothIcon },
  { name: "Sophie the Swamp Witch", image: sophieIcon },
  { name: "Xandra the Xweetok", image: xandraIcon },
  { name: "Ylana Skyfire", image: ylanaIcon },
];
